import { withLocalState } from 'pyradux';

import ChannelsContainer from './Channels.container';
import reducer from './Channels.reducer';
import ChannelsSagas from './Channels.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'channels',
  sagas: [ChannelsSagas],
};

export default withLocalState(withLocalStateOptions, ChannelsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Channels/index.js